import axios from "axios";
import { isObject } from "lodash";
import * as types from "../actions/actionTypes";

const NO_USERNAME_APPEND = ["/api/calls/batch"];

let store;

export const injectStore = (_store) => {
  store = _store;
};

const instance = axios.create();

async function onResponse(response) {
  return response;
}

async function onRequest(config) {
  const token = localStorage.getItem("grav_token");
  const username = localStorage.getItem("username");
  if (token) {
    if (config.data) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in config.data) {
        if (
          // key !== 'token' &&
          isObject(config.data[key]) &&
          !Array.isArray(config.data[key])
        ) {
          // append active user to all requests w/ body to maintain audit trail
          if (!NO_USERNAME_APPEND.includes(config.url)) {
            if (config.method === "post") {
              config.data[key].created_by = username;
            } else {
              config.data[key].modified_by = username;
            }
          }
        }
      }
    }

    // Append token to all request headers
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.username = username;
  }
  return config;
}

let refreshPromise = null;

async function onError(error) {
  const originalRequest = error.config;
  const { status } = error.response;

  if (status === 403 && !originalRequest._retry) {
    const refreshToken = localStorage.getItem("gv_refresh_token");
    if (refreshToken && originalRequest.url !== "/api/refresh") {
      originalRequest._retry = true;
      if (!refreshPromise) {
        refreshPromise = axios
          .post("/api/refresh", { refreshToken })
          .catch((error) => {
            if (
              error.response.status === 500 &&
              error.response.data?.errors?.message === "jwt expired"
            ) {
              store?.dispatch({ type: types.AUTH_REFRESH_FAILURE });
            }
            return Promise.reject(error);
          })
          .finally(() => {
            refreshPromise = null;
          });
      }
      const { data } = await refreshPromise;
      localStorage.setItem("gv_refresh_token", data.tokens.refresh.token);
      localStorage.setItem("grav_token", data.tokens.access.token);
      originalRequest.headers.Authorization = `Bearer ${data.tokens.access.token}`;
      return axios(originalRequest);
    }
    store?.dispatch({ type: types.AUTH_REFRESH_FAILURE });
  }

  return Promise.reject(error);
}

instance.interceptors.request.use(onRequest, onError);
instance.interceptors.response.use(onResponse, onError);

export default instance;
